<template>
  <div class="bookings">
    <div class="bookings-title">
      <span>Transactions</span>
      <a @click="isShow = !isShow">{{ isShow ? "Less" : "More" }}</a>
    </div>
    <div v-for="b in bookings" :key="b.id" :class="{ refund: b.is_refund }" class="booking">
      <div class="row pri">
        <span class="detail">{{ b.description }}</span>
        <span v-if="isHidePrices" class="val">NA</span>
        <span v-else-if="!b.cost_other" class="val white-label-off">{{ b.cost_label }}</span>
        <span v-else class="val">{{ b.cost_currency }} {{ (b.cost + (b.cost_other || 0)).toFixed(2) }}</span>
      </div>
      <div class="details" :class="{ show: isShow }">
        <div v-if="b.cost_card == 'Voucher' && b.cost > 0" class="row muted white-label-off">
          <span class="detail">{{ b.cost_card }}</span>
          <span class="val">USD {{ b.cost.toFixed(2) }}</span>
        </div>
        <div class="row muted white-label-off">
          <span class="detail">Charged by</span>
          <span class="val">{{ chargedby(b) }}</span>
        </div>
        <template v-if="(et = eTickets(b.id))">
          <div class="row muted">
            <span class="detail">Confirmation #</span>
            <span class="val">{{ confirmationShow(et) }}</span>
          </div>
          <div v-if="et.is_flight" class="row muted">
            <span class="detail">eTicket #</span>
            <span class="val noprint">
              <a v-if="et.etickets.length > 1" @click="eticketIsShow = !eticketIsShow">{{ eticketIsShow ? "Hide" : "Show" }}</a>
              <span v-else>{{ eticketSingle(et) }}</span>
            </span>
          </div>
          <div v-if="et.is_flight" v-show="eticketIsShow" class="etickets">
            <div v-for="t in eticketMore(et)" :key="t.name" class="row">
              <span class="detail">{{ t.name }}</span>
              <span class="val">{{ t.eticket }} </span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  bookings: Array,
  confirmations: Array,
  isHidePrices: Boolean,
});

const chargedby = b => {
  var chargedBy = b.cost_merchant;

  if (b.cost_card === "Voucher") {
    chargedBy += ` (${b.cost_card})`;
  } else if (b.cost > 0 && b.cost_other) {
    chargedBy += ` (Split cost)`;
  } else if (b.cost_card) {
    chargedBy += ` on ${b.cost_card}`;
  }

  return chargedBy;
};

const eTickets = bookingId => {
  const et = props.confirmations.filter(c => c.booking_id === bookingId);
  return et.length > 0 ? et[0] : null;
};

const confirmationShow = cf => {
  if (!cf.confirmations) return "N/A";

  var confirmations = [];
  cf.confirmations.forEach(c => confirmations.push(c.provider.length == 2 ? `${c.pnr} (${c.provider})` : c.pnr));
  return confirmations.join(", ");
};

const isShow = ref(false);
const eticketIsShow = ref(false);

const eticketMore = et => {
  var res = [];
  et.etickets.forEach(t => {
    res.push({
      name: [t.passport_first_name, t.passport_middle_name, t.passport_last_name].join(" "),
      eticket: t.eticket || "N/A",
    });
  });

  return res.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
};

const eticketSingle = et => {
  // Return the first eTicket number
  const t = et.etickets[0];
  return [t.passport_first_name, t.passport_middle_name, t.passport_last_name].join(" ") + ": " + (t.eticket || "N/A");
};
</script>

<style lang="less">
#itineraries {
  .bookings {
    border-top: 0.0625rem solid @light;
    padding: 2rem;
  }

  .bookings-title {
    display: flex;
    margin-bottom: 1rem;

    span {
      flex: 1;
      font-weight: bold;
    }
  }

  .booking {
    .row {
      display: flex;

      &.pri {
        margin-bottom: 0.5rem;
      }
    }

    .details {
      display: none;
      margin-bottom: 2rem;

      &.show {
        display: block;
      }
    }

    .detail {
      flex: 1;
    }

    .description {
      margin-bottom: 0.5rem;
    }

    .travelers {
      color: @mid;
      line-height: 1.5;
    }

    &:last-child {
      border: none;
      margin-bottom: 0;
      padding-bottom: 0;

      .details {
        margin-bottom: 0;
      }
    }
  }

  .etickets {
    margin-top: 1rem;
  }
}
</style>
